<app-loading-spinner *ngIf="!loaded;else main_content"></app-loading-spinner>
<ng-template #main_content>
    <div class="sparcBox mb-4 w-100" *ngIf="speakingScore && speakingScoreHistory && (currentCourse.CourseCode !== 'Pathways')">
        <app-student-sparc-details [speakingScore]="speakingScore" [speakingScoreHistory]="speakingScoreHistory"
            [isShowingWida]="false"
            [class]="col-12">
        </app-student-sparc-details>
        <div class="description">Based on most recent 20 speaking opportunities</div>
    </div>
    <div class="domainWidaBox mb-4">
        <app-student-domain-scores [scores]="domainScores" style="width: 49%"></app-student-domain-scores>
        <app-wida-widget [widaPredictionDetails]="widaPredictionDetails" style="width:49%"></app-wida-widget>
    </div>
    <div class="d-flex align-items-end mb-4">
        <h2>Progress for: </h2>
        <select class="form-control ml-3" style="width: fit-content" [ngModel]="currentCourse.CourseCode"
            (ngModelChange)="selectCourse($event)">
            <option *ngFor="let course of selectableCourses" [disabled]="course.CourseCode === 'Default'"
                [ngValue]="course.CourseCode">
                {{ course.CourseDescription }}
            </option>
        </select>
    </div>
    <app-student-progress-report-kinder *ngIf="isKinder()" [currentCourse]="currentCourse" [studentId]="studentId" [courses]="courses"></app-student-progress-report-kinder>
    <app-student-progress-report-pathways *ngIf="isPathways()" [courseSummaries]="courseProgressSummaries" [studentId]="studentId"></app-student-progress-report-pathways>
</ng-template>